import { useEffect, useState } from "react";

export default function useThemaCodes() {
	const [codes, setCodes] = useState(null);

	useEffect(() => {
		import("astrid-config/src/genres/20250415_Thema_v1.6_sv.json").then((data) => {
			setCodes(data.default.CodeList.ThemaCodes.Code);
		});
	}, []);

	return codes;
}
